import CourseAPI from '../../../../api/CourseAPI';
import showAppError from '../../../../shared/error';
import { ICourse, ICoursesRequest } from '../../../../types/courseTypes';

export type CourseCardStatusBadge = 'new' | 'completed' | null;

export interface CourseCardPresentation {
  percent: number;
  showProgress: boolean;
  categoryLabel: string;
  statusBadge: CourseCardStatusBadge;
  ctaLabel: string;
}

export function getCourseProgressPercent(course: ICourse): number {
  if (typeof course.progress === 'number') {
    return Math.min(100, Math.max(0, course.progress));
  }
  const p = course.progress?.progress;
  return typeof p === 'number' ? Math.min(100, Math.max(0, p)) : 0;
}

export function isCourseCompleted(course: ICourse, percent: number): boolean {
  if (percent >= 100) return true;
  if (
    typeof course.progress !== 'number' &&
    course.progress?.certificateStatus === 'completed'
  ) {
    return true;
  }
  return false;
}

export function getCourseCardPresentation(
  course: ICourse,
  newCourseCta: string,
): CourseCardPresentation {
  const pct = getCourseProgressPercent(course);
  const done = isCourseCompleted(course, pct);
  const inProgress = !done && pct > 0 && pct < 100;
  const isPaidLocked = !!course.paidCourse;

  let status: CourseCardStatusBadge = null;
  if (isPaidLocked) {
    if (!done && pct === 0) {
      status = 'new';
    }
  } else if (done) {
    status = 'completed';
  } else if (pct === 0) {
    status = 'new';
  }

  const category = course?.category?.name
    ? course?.category?.name?.toUpperCase?.()
    : null;

  let cta = 'View Course';
  if (isPaidLocked) {
    cta = 'Buy now to unlock';
  } else if (inProgress) {
    cta = 'Continue';
  } else if (!done && pct === 0) {
    cta = newCourseCta;
  }

  return {
    percent: Math.round(pct),
    showProgress: isPaidLocked ? false : inProgress,
    categoryLabel: category || '',
    statusBadge: status,
    ctaLabel: cta,
  };
}

export const COURSE_CARD_FALLBACK_COVER =
  'https://tagmango.com/staticassets/-best-tools-to-create-animated-videos-d1f0d8129db439edcce5b40b12666d15.webp';

export const getCoursesForFeedCards = async ({
  objQuery,
}: {
  objQuery: ICoursesRequest;
}) => {
  const errorMsg = 'Failed to load courses.';
  try {
    const resp = await CourseAPI.getCourses(objQuery);
    if (resp.status === 200) {
      return resp.data.result;
    }
    showAppError(resp.data, errorMsg);
    return [];
  } catch (error: any) {
    showAppError(error, errorMsg);
    return [];
  }
};
